/* eslint-disable max-len */
/* eslint-disable no-plusplus */
// libraries
import React from 'react';
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import { CheckCircle, NavigateBefore, Send } from '@material-ui/icons';

// js
import defaultSound from '../../../assets/images/defaultSound.png';
import {
    ContainerAdjustIconEdit,
    ContainerOptions,
    InputNullSelectedPhoto,
    Logo,
    TitleOption,
} from '../modulesStyles';

// interfaces
import type { DataModuleInterface, TaskAssociateTextAudioInterface } from '../modulesInterfaces';
import uploads from '../../../services/uploads';
import tasks from '../../../services/tasks';

const TaskAssociateTextAudio = (
    setIdModal: any,
    initialDataTaskAssociateTextAudio: TaskAssociateTextAudioInterface,
    taskAssociateTextAudio: TaskAssociateTextAudioInterface,
    setTaskAssociateTextAudio: any,
    dataModule: DataModuleInterface,
) => {
    // constants
    const token: any = String(localStorage.getItem('token') || '');
    const adjustMarginBottom = { marginBottom: 10 };
    const adjustButtonLogo = { marginBottom: 25, width: 200 };
    const adjustWidthSelectedActivities = { width: 200 };

    // methods
    const BackScreenModal = () => {
        setIdModal(1);
        setTaskAssociateTextAudio(initialDataTaskAssociateTextAudio);
    };

    const CreateTask = async () => {
        const formatTask: any = {
            ...taskAssociateTextAudio,
            idTask: taskAssociateTextAudio.id,
            idModule: dataModule?.id,
            target: 1,
        };
        delete formatTask?.id;
        if (formatTask?.idTask) {
            const editTask: any = await tasks.EditTask(formatTask, token);
            if (editTask) {
                BackScreenModal();
            }
        } else {
            delete formatTask?.idTask;
            const createTask: any = await tasks.CreateTask(formatTask, token);
            if (createTask) {
                BackScreenModal();
            }
        }
    };

    const onChangeTitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskAssociateTextAudio, title: txt.target.value };
            setTaskAssociateTextAudio(newDataTask);
        }
    };

    const onChangeSubtitle = (txt: any) => {
        if (txt.target.value.length <= 5000) {
            const newDataTask = { ...taskAssociateTextAudio, subtitle: txt.target.value };
            setTaskAssociateTextAudio(newDataTask);
        }
    };

    const onChangeOptionSkipTask = (txt: any) => {
        const newDataTask = { ...taskAssociateTextAudio, skip: txt.target.value };
        setTaskAssociateTextAudio(newDataTask);
    };

    const validationDisabled = () => {
        let valueObject = true;
        if (taskAssociateTextAudio?.id) {
            const ValidationLength = Object.values(taskAssociateTextAudio).filter((v) => v !== '').length !== 6;
            if (!ValidationLength) {
                valueObject = false;
            }
        } else if (!taskAssociateTextAudio?.id) {
            const ValidationLength = Object.values(taskAssociateTextAudio).filter((v) => v !== '').length !== 5;
            if (!ValidationLength) {
                valueObject = false;
            }
        }
        return valueObject;
    };

    const validationBackground = () => {
        const valueObject = Object.values(taskAssociateTextAudio).filter((v) => v !== '');
        if ((taskAssociateTextAudio?.id ? valueObject.length === 6 : valueObject.length === 5)) {
            return 'primary';
        }

        return 'inherit';
    };

    // renders
    const RenderSelectedCorrectOptions = (skipTask: boolean) => {
        if (!skipTask) {
            const SelectedAudio = async (event: any) => {
                if (event.target.files.length) {
                    const newDataFiles = {
                        eventFile: event.target.files[0],
                        eventName: event.target.files[0].name,
                        file: URL.createObjectURL(event.target.files[0]),
                    };
                    const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                    if (upload) {
                        setTaskAssociateTextAudio({ ...taskAssociateTextAudio, file: upload.result });
                        // eslint-disable-next-line no-param-reassign
                        event.target.value = null;
                    }
                }
            };

            return (
                <>
                    <Button
                        style={adjustButtonLogo}
                        title={taskAssociateTextAudio?.file}
                    >
                        <Logo src={defaultSound} />
                        {taskAssociateTextAudio?.file ? (
                            <ContainerAdjustIconEdit right="40px" style={adjustMarginBottom}>
                                <CheckCircle color="inherit" />
                            </ContainerAdjustIconEdit>
                        ) : null}
                        <InputNullSelectedPhoto
                            accept=".mp3,audio/*"
                            onChange={SelectedAudio}
                            type="file"
                        />
                    </Button>
                    <FormControl style={adjustWidthSelectedActivities}>
                        <InputLabel>Pular/Não pular</InputLabel>
                        <Select
                            value={taskAssociateTextAudio.skip}
                            onChange={onChangeOptionSkipTask}
                        >
                            <MenuItem value="true">Pular</MenuItem>
                            <MenuItem value="false">Não pular</MenuItem>
                        </Select>
                    </FormControl>
                </>
            );
        }

        return null;
    };

    const RenderInputsTitles = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <>
                <ContainerOptions marginTop="10px" />
                <TextField
                    fullWidth
                    label={`${label} (${ValueActual.length}/200)`}
                    onChange={onChange}
                    value={value}
                />
            </>
        );
    };

    const EndIcon = () => (
        <Send />
    );

    const RenderIconGoBack = () => (
        <NavigateBefore />
    );

    return (
        <>
            <ContainerOptions>
                <TitleOption width="100%">Criação da Atividade - Associe o texto ao áudio</TitleOption>
            </ContainerOptions>
            {RenderInputsTitles('Título da atividade', taskAssociateTextAudio.title, onChangeTitle)}
            <ContainerOptions marginTop="10px" />
            <TextField
                fullWidth
                label={`Subtítulo da atividade (${taskAssociateTextAudio.subtitle.length}/5000)`}
                onChange={onChangeSubtitle}
                value={taskAssociateTextAudio.subtitle}
                rows={3}
                margin="normal"
                variant="outlined"
                multiline
            />
            {/* fullWidth
            label="Descrição"
            margin="normal"
            onChange={handleChangeDescription}
            rows={3}
            value={description}
            variant="outlined"
            multiline */}
            <ContainerOptions marginTop="10px" width="50%">
                {RenderSelectedCorrectOptions(false)}
            </ContainerOptions>
            <ContainerOptions marginTop="40px">
                <Button
                    color="primary"
                    startIcon={RenderIconGoBack()}
                    onClick={BackScreenModal}
                    variant="contained"
                >
                    Voltar
                </Button>
                <Button
                    color={validationBackground()}
                    disabled={validationDisabled()}
                    endIcon={EndIcon()}
                    onClick={CreateTask}
                    variant="contained"
                >
                    {taskAssociateTextAudio?.id ? 'Editar Atividade' : 'Criar Atividade'}
                </Button>
            </ContainerOptions>
        </>
    );
};

export default TaskAssociateTextAudio;
